const readableRoleCode = (value) => String(value || '')
  .trim()
  .replace(/[-_]+/g, ' ')
  .replace(/\b\w/g, (character) => character.toUpperCase());

export const getNavigationRoleLabel = (user, fallbackAdminLabel, superAdminLabel) => {
  if (user?.isSuperAdmin === true) return superAdminLabel;

  const permissionRoles = Array.isArray(user?.permissionRoles) ? user.permissionRoles : [];
  const legacyRoles = Array.isArray(user?.roles) ? user.roles : [];
  const roleLabels = Array.from(new Set(
    (permissionRoles.length > 0 ? permissionRoles : legacyRoles)
      .map((role) => String(role?.name || readableRoleCode(role?.code)).trim())
      .filter(Boolean)
  ));

  return roleLabels.join(' · ') || fallbackAdminLabel;
};
